import { jsxs as c, jsx as n } from "react/jsx-runtime";
import { createElement as f } from "react";
import _ from "classnames";
import { FormattedMessage as I } from "react-intl";
import { I as o } from "./Icon-BcAne5bE.js";
const l = {
  alertSupDefault: "#26A4AB",
  alertInfDefault: "#FFA726"
}, A = ({
  icons: e,
  label: r,
  input: i,
  className: d,
  colorMode: p = "light",
  type: s = "neutral",
  size: t = "medium",
  disabled: u = !1,
  ...m
}) => /* @__PURE__ */ c(
  "div",
  {
    ...m,
    className: _(
      d,
      "ds-chip",
      `ds-chip--${s}`,
      `ds-chip--${p}-bg`,
      `ds-chip--${t}`,
      {
        "ds-chip--disabled": u
      }
    ),
    children: [
      !e && w(s) && /* @__PURE__ */ n(
        o,
        {
          path: g(s, t),
          size: 24,
          className: "ds-chip__set-type-icon",
          color: $(s, t)
        }
      ),
      e?.map((a, h) => /* @__PURE__ */ f(
        o,
        {
          ...a,
          key: `${a.path}-${h}`,
          size: a.size ?? "small",
          className: `ds-chip--icon-${a.placement}`
        }
      )),
      /* @__PURE__ */ c("div", { children: [
        r && /* @__PURE__ */ c("span", { className: "ds-chip__label", children: [
          r,
          /* @__PURE__ */ n(I, { id: "misc-colon", defaultMessage: ":" })
        ] }),
        /* @__PURE__ */ n("span", { className: "ds-chip__input", children: i })
      ] })
    ]
  }
), w = (e) => {
  switch (e) {
    case "neutral":
    case "correct":
    case "incorrect":
    case "outlined":
      return !1;
    default:
      return !0;
  }
}, g = (e, r) => {
  switch (e) {
    case "conf":
      return "conf_3d";
    case "sup":
      return r === "small" ? "arrow_drop_up" : "sup_3d";
    case "inf":
      return r === "small" ? "arrow_drop_down" : "inf_3d";
    default:
      throw new Error(`Icon path not configure for type ${e} in Chip`);
  }
}, $ = (e, r) => {
  switch (e) {
    case "sup":
      return r === "small" ? l.alertSupDefault : void 0;
    case "inf":
      return r === "small" ? l.alertInfDefault : void 0;
    default:
      return;
  }
};
export {
  A as C
};
//# sourceMappingURL=Chip-B4C1Yxjw.js.map
